import "core-js/stable";
import "regenerator-runtime/runtime";

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import 'core/bootstrap';
import App from 'core/App';
import store from 'core/reducer';

// Import Framework7
import Framework7 from 'framework7/framework7.esm.bundle.js'

// Import Framework7-React Plugin
import Framework7React from 'framework7-react'

// Import Framework7 Styles
import 'framework7/css/framework7.bundle.rtl.min.css'

// Import Icons and App Custom Styles
if (process.env.NODE_ENV === 'development') {
  // import 'assets/layout/app/styles/main.css'
  import ('./assets/layout/app/styles/app.1.css')
}

Framework7.use(Framework7React)

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('app')
)
